function fallbackCopyTextToClipboard(text, successCb, errorCb) {
  const textArea = document.createElement('textarea');
  textArea.value = text;

  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    const success = document.execCommand('copy');
    if (!success || !successCb) {
      return;
    }
    successCb();
  } catch (err) {
    if (!errorCb) {
      return;
    }
    errorCb(err);
  }

  document.body.removeChild(textArea);
}

export default function copyTextToClipboard(text, successCb, errorCb) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text, successCb, errorCb);
    return;
  }
  navigator.clipboard.writeText(text).then(
    () => {
      if (!successCb) {
        return;
      }
      successCb();
    },
    (err) => {
      if (!errorCb) {
        return;
      }
      errorCb(err);
    },
  );
}
